import { codes } from 'micromark-util-symbol'

export const PRIMARY_SYMBOL = codes.lessThan
export const PRIMARY_SYMBOL_STR = '>'